import { render, staticRenderFns } from "./WxCode.vue?vue&type=template&id=0887a650&scoped=true"
import script from "./WxCode.vue?vue&type=script&lang=js"
export * from "./WxCode.vue?vue&type=script&lang=js"
import style0 from "./WxCode.vue?vue&type=style&index=0&id=0887a650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887a650",
  null
  
)

export default component.exports